/* import __COLOCATED_TEMPLATE__ from './revisions.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./revisions.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());